import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {CoreDI, DefaultEventsMap, Device, FullscreenManager, IEventManagerWithAsync, inject, SlotSettings} from '@gongxigames/framework/slot';
import {UIMenuBarEvents, uiMenuEmitter} from '@gongxigames/framework/slotV2/ui/services/UIMenu/UIMenuEmitter';
import {uiMenuStore} from '@gongxigames/framework/slotV2/ui/services/UIMenu/uiMenuStore';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

// TODO Remove not strict events
export class UIMenuService extends UiServiceV2 {
    public static NAME = 'UIMenuService';

    // TODO convert to signals/move to store
    @inject(CoreDI.Settings)
    protected settings!: SlotSettings;

    @inject(CoreDI.FullscreenManager)
    private _fullscreenManager!: FullscreenManager;

    @inject(CoreDI.Device)
    private _device!: Device;

    /**
     * // TODO: refactor
     * @deprecated
     */
    @inject(CoreDI.IEventManagerWithAsync)
    protected _eventManager!: IEventManagerWithAsync<DefaultEventsMap>;

    public onSetupEvents(): void {
        uiMenuEmitter.on('home', () => this.emitter.emit('UI.command.home'));
        uiMenuEmitter.on('fullscreen', this.onFullscreenClicked.bind(this));
        uiMenuEmitter.on('info', this.onPaytableClicked.bind(this));
        uiMenuEmitter.on('game_rules', this.onGameRulesClicked.bind(this));
        uiMenuEmitter.on('history', this.onGameHistoryClicked.bind(this));
        uiMenuEmitter.on('cashier', this.onCashierClicked.bind(this));
        uiMenuEmitter.on('support', this.onSupportClicked.bind(this));
        uiMenuEmitter.on('logout', this.onLogoutClicked.bind(this));
        uiMenuEmitter.on('close',this.onMenuBarClosed.bind(this));

        this.emitter.on('UI.command.menu', this.onMenuBarOpen.bind(this));
        this._eventManager.on('General.Popups.Add', this.onMenuBarClosed.bind(this), this);
    }

    private onFullscreenClicked(): void {
        this.emitter.emit('UI.command.fullScreen', true);

        if (this._device.fullscreen) {
            if (this._fullscreenManager.isFullscreen()) {
                this._fullscreenManager.exitFullscreen();
            } else {
                this._fullscreenManager.requestFullscreen();
            }
        }
    }

    public openMenuBar(): void {
        uiMenuStore.menuOpened.value = true;
        this.openInfoPageByDefault();
        this.emitter.emit('UI.menu.opened');
    }

    public closeMenuBar(): void {
        uiMenuStore.menuOpened.value = false;

        this.emitter.emit('UI.menu.closed');
        this.emitter.emit('UI.menu.menuBarClosed');
    }

    public openPaytable(): void {
        this.setActiveButton('info');

        this.emitter.emit('UI.menu.closed');
        this.emitter.emit('UI.menu.infoPageClicked');
    }

    public openGameRules(): void {
        this.setActiveButton('game_rules');

        this.emitter.emit('UI.menu.closed');
        this.emitter.emit('UI.menu.gameRulesClicked');
    }

    public openGameHistory(): void {
        if (this.settings.get('gameHistoryListEnabled')) {
            this.setActiveButton('history');

            this.emitter.emit('UI.menu.closed');
        }

        this.emitter.emit('UI.menu.historyButtonClicked');
    }

    protected setActiveButton(button: keyof UIMenuBarEvents): void {
        uiMenuStore.activePage.value = button;
    }

    protected onMenuBarOpen(): void {
        slotStore.soundPlayer.value?.play('buttonclick');
        this.openMenuBar();
    }

    protected openInfoPageByDefault(): void {
        this.setActiveButton('info');

        this.emitter.emit('UI.menu.infoPageClicked');
    }

    protected onMenuBarClosed(): void {
        slotStore.soundPlayer.value?.play('buttonclick');
        this.closeMenuBar();
    }

    protected onPaytableClicked(): void {
        slotStore.soundPlayer.value?.play('buttonclick');
        this.openPaytable();
    }

    protected onGameRulesClicked(): void {
        slotStore.soundPlayer.value?.play('buttonclick');
        this.openGameRules();
    }

    protected onGameHistoryClicked(): void {
        slotStore.soundPlayer.value?.play('buttonclick');
        this.openGameHistory();
    }

    protected onSupportClicked(): void {
        slotStore.soundPlayer.value?.play('buttonclick');
        this.emitter.emit('UI.menu.supportButtonClicked');
    }

    protected onCashierClicked(): void {
        slotStore.soundPlayer.value?.play('buttonclick');
        this.emitter.emit('UI.menu.cashierClicked');
    }

    protected onLogoutClicked(): void {
        slotStore.soundPlayer.value?.play('buttonclick');

        this.emitter.emit('UI.menu.logoutButtonClicked');
    }
}